var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.24609 17.0938C2.24609 17.4389 2.52592 17.7188 2.87109 17.7188H10.8236C10.9617 17.7188 11.0736 17.6068 11.0736 17.4688V16.4062C11.0736 16.2682 10.9617 16.1562 10.8236 16.1562H3.80859L3.80859 3.84375L10.8236 3.84375C10.9617 3.84375 11.0736 3.73182 11.0736 3.59375V2.53125C11.0736 2.39318 10.9617 2.28125 10.8236 2.28125H2.87109C2.52592 2.28125 2.24609 2.56107 2.24609 2.90625V17.0938ZM13.7707 14.2424C13.673 14.3401 13.5147 14.3401 13.4171 14.2424L12.6658 13.4911C12.5682 13.3935 12.5682 13.2352 12.6658 13.1376L15.0222 10.7812L5.46484 10.7812C5.32677 10.7812 5.21484 10.6693 5.21484 10.5312V9.46869C5.21484 9.33062 5.32677 9.21869 5.46484 9.21869L15.0223 9.21869L12.6659 6.86234C12.5683 6.76471 12.5683 6.60642 12.6659 6.50879L13.4172 5.75749C13.5149 5.65986 13.6732 5.65986 13.7708 5.75749L17.5714 9.55785C17.6405 9.62701 17.6901 9.70836 17.7201 9.79499C17.796 10.0141 17.7465 10.2671 17.5715 10.4421L13.7707 14.2424Z",
    fill: "#070A26"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.163df27c82457665dac72ff77a4156ce.svg";
export { ForwardRef as ReactComponent };